/**
 * @file 收录数据、公共资源（认证/收录）和企业标记
 * @author chenyuyang
 */
import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import {useDispatch} from 'react-redux';
import {Popover, Modal, message, Input} from 'antd';
import {submitEvaluation} from '../../../../actions/businessCard';
import {getAssessmentStatic} from '../../../../actions/searchAction';
import {bCat_2055_request, recordProxy} from '../../../../util';
import CustomButton from '../../../../components/CustomButton/index.tsx';
import iconScan from '../../imgs/icon-scan.svg';
import iconGoodFingerGray from '..//../../../asset/img/businessCard/pjgood.png';
import iconGoodFingerRed from '..//../../../asset/img/businessCard/haspj.svg';
import iconAuth from '../../../../asset/img/businessCard/auth-icon.svg';
import iconEdit from '../../imgs/icon-edit.svg';
import './style.less';
const {TextArea} = Input;
const Message = message;
Message.config({
    maxCount: 1,
});
const Custom = (props) => {
    const {
        data = {}, search, login,
        secmRecord, isZhuKa, isDianHuaBang
    } = props || {};
    const {customer, poi} = data;
    const history = useHistory();

    const formateUrl = (url) => {
        if (url) {
            return url.indexOf('http') > -1 ? url : 'http://' + url;
        } else {
            return '';
        }
    };
    let title = '';
    let phoneList = [];
    let webUrl = '';
    let pcText = '';
    let label = '0';
    let textColor = '';
    if (poi) {
        // 企业电话
        title = poi[0]?.name || search;
        phoneList = poi[0].phone || [];
        webUrl = formateUrl(poi[0].url);
        pcText = poi[0].textLabel;
        label = poi[0].label;
        textColor = poi[0].textColor;
    } else if (customer) {
        // 客服电话
        title = customer[0]?.title || search;
        phoneList = customer[0].phone_list || [];
        webUrl = formateUrl(customer[0].url);
        pcText = customer[0].textLabel;
        label = customer[0].label;
        textColor = customer[0].textColor;
    }

    const [visible, setVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [attestCount, setAttestCount] = useState(0);
    const dispatch = useDispatch();
    const [evaluationData, setEvaluationData] = useState({
        r: 0,
        s: 0,
        a: 0,
        d: ''
    });
    const [tipInfo, setTipInfo] = useState('');
    const [assessmentInfo, setAssessmentInfo] = useState({});
    useEffect(() => {
        let count = phoneList.filter(item => item.payed === 1);
        setAttestCount(count.length);
        let tipInfo = '';
        if (isZhuKa) {
            tipInfo = count.length ? count.length === phoneList.length ? '号码已认证，放心拨打' : '部分号码经认证，仅供参考' : '以下号码仅供参考';
        } else {
            tipInfo = pcText || '';
        }
        fetchAssessmentStatic(title);
        setTipInfo(tipInfo);
    }, []);
    const handleVisibleChange = visible => {
        setVisible(visible);
    };
    const qrCodeUrl = (
        window.location.host.indexOf(':8066') > -1
        || window.location.host.indexOf('safe-mobsec06.bcc-bdbl.baidu.com') > -1)
        ? 'http://safe-mobsec06.bcc-bdbl.baidu.com:8879' : 'https://mhaoma.baidu.com';
    /* eslint-disable */
    const qrCode = <img className='qr-code' src={window.location.origin
        + '/api/v1/qr_code?url='
        + encodeURIComponent(
            `${qrCodeUrl}/pages/search-result/search-result?search=${props.search}&scan=true`
        )}></img>

    const toEvaluation = () => {
        secmRecord('goEvaluation');
        if (login) {
            setModalVisible(true);
        } else {
            message.error('请先登录');
        }
    }
    const onEvaluation = (type, e) => {
        switch (type) {
            case 'r':
            case 'a':
            case 's':
                setEvaluationData({
                    ...evaluationData,
                    [type]: evaluationData[type] === 1 ? 0 : 1
                })
                break;
            case 'd':
                setEvaluationData({
                    ...evaluationData,
                    d: e.target.value
                })
                break;
            default:
        }
    }
    const fetchAssessmentStatic = (title) => {
        const getAsset = params => getAssessmentStatic(dispatch, {
            ...params,
            content: title,
        }).then(res => {
            const {code, data = {}} = res || {};
            if (code === 200) {
                setAssessmentInfo(data.statistics);
            }
        });
        bCat_2055_request(getAsset);
    }
    const evaluationSubmit = (e) => {
        const submit = (params) => submitEvaluation(dispatch, {
            ...params,
            content: title,
            r: evaluationData.r,
            a: evaluationData.a,
            s: evaluationData.s,
            d: evaluationData.d,
        }).then(res => {
            const {code, message} = res || {};
            setModalVisible(false);
            if (code === 200) {
                Message.success('提交成功');
            } else {
                Message.warning(message);
            }
        });
        bCat_2055_request(submit);
    }
    const onAuthJump = () => {
        recordProxy('phone-search-customer', 'click', 'attest-step-1');
        history.push('/attest/step/1');
    };
    const showUrl = webUrl && (webUrl.indexOf('https://haoma.baidu.com') < 0);
    const {r_count, a_count, s_count, total} = assessmentInfo || {};
    return (
        <div className="comp-custom">
            <div className="title-wrapper">
                <div className="title-info">
                    <div className="title">{title}</div>
                    <div className="evaluation" onClick={toEvaluation}>
                        <img src={iconEdit} className="icon-edit"></img>评价
                    </div>
                </div>
                <div className="tip">
                    {/* <p className="tip">{tipInfo}{isDianHuaBang ? '*' : ''}</p> */}
                    {pcText && <div className={textColor ? `tag-type ${textColor}` : 'tag-type'}>
                        {label === '1' && <div className="auth-tag-wrap">
                            <img className="auth-tag" src={iconAuth} />
                        </div>}
                        <div className="tag-text">
                            {pcText}
                        </div>
                    </div>}
                    {pcText === '官方号码'
                        && <span className="auth-text" onClick={onAuthJump}>政府/非盈利组织认证 &gt;</span>}
                </div>
                <div className="evaluation-info">
                    {total ? <span className="tag">全部&nbsp;{assessmentInfo.total}</span> : ''}
                    {r_count ? <span className="tag">电话接通快&nbsp;{assessmentInfo.r_count}</span> : ''}
                    {a_count ? <span className="tag">号码准确&nbsp;{assessmentInfo.a_count}</span> : ''}
                    {s_count ? <span className="tag">问题得到解决&nbsp;{assessmentInfo.s_count}</span> : ''}
                </div>
            </div>
            <div className="tel-info">
                {phoneList.map(item => {
                    return (
                        <div className="tel-list" key={item.phone || item.number}>
                            {item.name && <div className={`tel-name ${phoneList.length === 1 ? 'single' : ''}`}>
                                <span className="name">{item.name}{phoneList.length === 1 ? '：' : ''}</span>
                                {item.payed === 1 && attestCount !== phoneList.length && <span className="report-tag">认证</span>}
                            </div>}
                            <span className="tel">{item.phone || item.number}</span>
                        </div>
                    );
                })}
                {showUrl && <div className="website">
                    <span className="website-title">公司官网：</span>
                    <span>{webUrl}</span>
                </div>}
                <Popover
                    content={qrCode}
                    trigger="hover"
                    open={visible}
                    onOpenChange={handleVisibleChange}
                    placement="bottom"
                    overlayClassName={'comp-custom-popover-class'}
                >
                    <CustomButton className="scan-btn" type="primary">
                        <img src={iconScan} className="icon-scan"></img>
                        扫码拨号
                    </CustomButton>
                </Popover>
            </div>
            <Modal
                title="评价"
                wrapClassName="normal-land-page-custom-modal"
                open={modalVisible}
                cancelText='取消'
                okText="提交"
                width={420}
                onOk={evaluationSubmit}
                onCancel={() => setModalVisible(false)}
            >
                <div className="modal-body">
                    <p className='title'>{title}</p>
                    <div className="evaluation-content">
                        <div className="list">
                            <div className="text">电话接通速度</div>
                            <div className="evaluation-event-wrapper" onClick={() => onEvaluation('r')}>
                                <span className="evaluation-tip">赞一下</span>
                                <img className='good-finger' src={evaluationData.r === 1 ? iconGoodFingerRed :iconGoodFingerGray}></img>
                            </div>
                        </div>
                        <div className="list">
                            <div className="text">号码准确</div>
                            <div className="evaluation-event-wrapper" onClick={() => onEvaluation('a')}>
                                <span className="evaluation-tip">赞一下</span>
                                <img className='good-finger' src={evaluationData.a === 1 ? iconGoodFingerRed :iconGoodFingerGray}></img>
                            </div>
                        </div>
                        <div className="list" onClick={() => onEvaluation('s')}>
                            <div className="text">问题得到解决</div>
                            <div className="evaluation-event-wrapper">
                                <span className="evaluation-tip">赞一下</span>
                                <img className='good-finger' src={evaluationData.s === 1 ? iconGoodFingerRed :iconGoodFingerGray}></img>
                            </div>
                        </div>
                        <div className="suggest">
                            <p className='top-tip'>评价内容或建议</p>
                            <TextArea
                                className='suggest-input'
                                placeholder="您还可以提交其他评价内容与建议，我们将反馈给企业，提升后续的服务质量。"
                                value={evaluationData.d}
                                onInput={(e) => onEvaluation('d', e)}
                            ></TextArea>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default Custom;